/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  MrfiktivCreatePartnerTemplateDtoGen,
  MrfiktivPartnerTemplateControllerDeleteParamsGen,
  MrfiktivPartnerTemplateControllerGetByKeyParamsGen,
  MrfiktivPartnerTemplateControllerRenderParamsGen,
  MrfiktivPartnerTemplateControllerUpdateParamsGen,
  MrfiktivPartnerTemplateViewModelGen,
  MrfiktivRenderedTemplateViewModelGen,
  MrfiktivRenderTemplateDtoGen,
  MrfiktivUpdatePartnerTemplateDtoGen
} from "./data-contracts";
import { ContentType, HttpClient, RequestParams } from "./http-client";

export class PartnerTemplate<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * No description
   *
   * @tags partner-template
   * @name PartnerTemplateControllerGetPreselectTemplateKeys
   * @summary (Partner) Get all known preselect template keys that can be used for template selection
   * @request GET:/partner/{partnerId}/template-keys
   * @secure
   * @response `200` `void` The list of known preselect template keys
   */
  partnerTemplateControllerGetPreselectTemplateKeys = (partnerId: string, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/partner/${partnerId}/template-keys`,
      method: "GET",
      secure: true,
      ...params
    });
  /**
   * No description
   *
   * @tags partner-template
   * @name PartnerTemplateControllerEnsureIndexes
   * @summary (ADMIN) Indexes templates
   * @request PATCH:/partner/template/ensureIndexesAsAdminAndMigrateLanguage
   * @deprecated
   * @secure
   * @response `200` `void`
   */
  partnerTemplateControllerEnsureIndexes = (params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/partner/template/ensureIndexesAsAdminAndMigrateLanguage`,
      method: "PATCH",
      secure: true,
      ...params
    });
  /**
   * No description
   *
   * @tags partner-template
   * @name PartnerTemplateControllerGetAll
   * @summary (Partner) Get all templates that are available for the partner
   * @request GET:/partner/{partnerId}/template
   * @secure
   * @response `200` `(MrfiktivPartnerTemplateViewModelGen)[]` The found ressources
   */
  partnerTemplateControllerGetAll = (partnerId: string, params: RequestParams = {}) =>
    this.http.request<MrfiktivPartnerTemplateViewModelGen[], any>({
      path: `/partner/${partnerId}/template`,
      method: "GET",
      secure: true,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags partner-template
   * @name PartnerTemplateControllerCreate
   * @summary (Partner) Post a partner template
   * @request POST:/partner/{partnerId}/template
   * @secure
   * @response `201` `MrfiktivPartnerTemplateViewModelGen` The created resource
   */
  partnerTemplateControllerCreate = (
    partnerId: string,
    data: MrfiktivCreatePartnerTemplateDtoGen,
    params: RequestParams = {}
  ) =>
    this.http.request<MrfiktivPartnerTemplateViewModelGen, any>({
      path: `/partner/${partnerId}/template`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags partner-template
   * @name PartnerTemplateControllerGetByKey
   * @summary (Partner) Get a template by key
   * @request GET:/partner/{partnerId}/template/{key}
   * @secure
   * @response `200` `MrfiktivPartnerTemplateViewModelGen` The found resource
   */
  partnerTemplateControllerGetByKey = (
    { partnerId, key, ...query }: MrfiktivPartnerTemplateControllerGetByKeyParamsGen,
    params: RequestParams = {}
  ) =>
    this.http.request<MrfiktivPartnerTemplateViewModelGen, any>({
      path: `/partner/${partnerId}/template/${key}`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags partner-template
   * @name PartnerTemplateControllerUpdate
   * @summary (Partner) Update a partner template
   * @request PATCH:/partner/{partnerId}/template/{key}
   * @secure
   * @response `200` `MrfiktivPartnerTemplateViewModelGen` The updated resource
   */
  partnerTemplateControllerUpdate = (
    { partnerId, key, ...query }: MrfiktivPartnerTemplateControllerUpdateParamsGen,
    data: MrfiktivUpdatePartnerTemplateDtoGen,
    params: RequestParams = {}
  ) =>
    this.http.request<MrfiktivPartnerTemplateViewModelGen, any>({
      path: `/partner/${partnerId}/template/${key}`,
      method: "PATCH",
      query: query,
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags partner-template
   * @name PartnerTemplateControllerDelete
   * @summary (Partner) Delete a partner template by key
   * @request DELETE:/partner/{partnerId}/template/{key}
   * @secure
   * @response `200` `MrfiktivPartnerTemplateViewModelGen` The deleted resource
   */
  partnerTemplateControllerDelete = (
    { partnerId, key, ...query }: MrfiktivPartnerTemplateControllerDeleteParamsGen,
    params: RequestParams = {}
  ) =>
    this.http.request<MrfiktivPartnerTemplateViewModelGen, any>({
      path: `/partner/${partnerId}/template/${key}`,
      method: "DELETE",
      query: query,
      secure: true,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags partner-template
   * @name PartnerTemplateControllerRender
   * @summary (Partner) Render a partner template
   * @request POST:/partner/{partnerId}/template/{key}/render
   * @secure
   * @response `201` `MrfiktivRenderedTemplateViewModelGen` The rendered template
   */
  partnerTemplateControllerRender = (
    { partnerId, key, ...query }: MrfiktivPartnerTemplateControllerRenderParamsGen,
    data: MrfiktivRenderTemplateDtoGen,
    params: RequestParams = {}
  ) =>
    this.http.request<MrfiktivRenderedTemplateViewModelGen, any>({
      path: `/partner/${partnerId}/template/${key}/render`,
      method: "POST",
      query: query,
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params
    });
}
